<template>
  <section class="hero">
    <div class="hero__orange">
      <div class="hero__bg hero__bg--1"></div>
      <div class="hero__logo-wrapper">
        <img src="../../assets/img/logo.png" alt="" class="hero__logo" />
      </div>
    </div>
    <div class="hero__black">
      <div class="hero__bg hero__bg--2"></div>
      <div class="hero__black-content">
        <div class="hero__black-texts">
          <p>
            The people you need, <br />
            where and when you need them.
          </p>
        </div>
        <div class="hero__black-button">
          <a href="#contact" class="btn">Let's talk</a>
        </div>
      </div>
    </div>
    <div class="hero__illus">
      <img src="../../assets/img/illust1.png" alt="Illustration 1" />
    </div>
    <div class="hero__cta">
      <p><arrow-down fillColor="#f05a28"></arrow-down> Learn more</p>
    </div>
    <div class="hero__bottom-texts">
      <div class="hero__bottom-texts-left">
        <h1 class="hero__bottom-texts-header">Our<br />Expertise</h1>
        <p class="hero__bottom-texts-sub-texts">
          We <span class="color-orange">partner</span> our clients to navigate
          the complex path that represents finding the right talent to
          successfully develop and
          <span class="color-orange">deliver software products</span>.
        </p>
      </div>
      <div class="hero__bottom-texts-right">
        <div class="hero__bottom-text-wrapper">
          <div class="hello"></div>
          <p class="hero__bottom-text">
            With our staffing and engineering solutions, we help you with the
            right match between the people you need and the challenge you have,
            whether it is building a project or a team to handle a variety of
            your main product requirements.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.hero {
  width: 100%;
  max-height: 140rem;
  position: relative;
  @include mq-max(1200px) {
    max-height: 145vh;
  }
  @include mq-max(450px) {
    max-height: unset;
  }
  @include mq-landscape() {
    max-height: unset;
  }
  &__orange {
    position: absolute;
    height: 40rem;
    width: 100%;
    @include mq-max(991px) {
      height: 100vh;
    }
  }
  &__bg {
    width: 100%;
    height: 100%;
    &--1 {
      background-image: linear-gradient(
          to bottom,
          rgba($primary-light, 0.3) 0%,
          rgba($primary, 0.8) 50%
        ),
        url(../../assets/img/bg2.jpg);
      background-position: center;
      clip-path: polygon(0 0, 50% 100%, 100% 0);
      @include mq-max(991px) {
        clip-path: polygon(-50% 0, 100% 50%, 100% 0%);
        background-size: cover;
        background-position: 50% -100px;
      }
    }
    &--2 {
      background-image: url(../../assets/img/bg3.jpg);
      background-repeat: no-repeat;
      clip-path: polygon(0 35%, 0 0, 100% 57%, 120% 100%);
      background-size: cover;
      background-position: center;
      position: relative;
      &:after {
        content: '';
        background-color: rgba(0, 0, 0, 0.3);
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
      @include mq-max(991px) {
        clip-path: polygon(0% 60%, 0% 16%, 100% 50%, 100% 90%);
      }
      @include mq-max(450px) {
        clip-path: polygon(0% 60%, 0% 16%, 100% 45%, 100% 90%);
      }
    }
  }
  &__logo-wrapper {
    position: absolute;
    left: 50%;
    top: 8rem;
    transform: translateX(-50%);
    @include mq-max(991px) {
      left: 65%;
      top: 7rem;
    }
    @include mq-max(450px) {
      left: 50%;
      top: 2rem;
      img {
        width: 15rem;
      }
    }
    @include mq-landscape {
      left: 80%;
      top: 2rem;
      img {
        width: 8rem;
      }
    }
  }
  &__black {
    position: relative;
    height: 140rem;
    width: 100%;
    @include mq-max(991px) {
      height: 100vh;
    }
    &-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &-texts {
      position: absolute;
      color: $white;
      font-family: Roboto;
      font-size: 4rem;
      font-weight: 500;
      letter-spacing: -0.2rem;
      line-height: 4rem;
      top: 25%;
      left: 6%;
      @include mq-max(1300px) {
        font-size: 2.5rem;
        line-height: 3rem;
      }
      @include mq-max(991px) {
        top: 35%;
        width: 60%;
      }
      @include mq-max(768px) {
        top: 37%;
        width: 60%;
      }
      @include mq-max(450px) {
        width: 65%;
        font-size: 2.2rem;
        line-height: 1;
        letter-spacing: -0.1rem;
      }
      @include mq-landscape {
        top: 38%;
        font-size: 1.4rem;
        line-height: 1.8rem;
        letter-spacing: -0.1rem;
      }
    }
    &-button {
      @include center-in-div;
      top: 43%;
      @include mq-max(991px) {
        left: 6%;
        top: 50%;
        transform: unset;
        text-align: left;
        width: auto;
        a {
          font-weight: 500;
          line-height: 2.8rem;
          text-align: center;
          padding: 0.5rem 1rem;
          font-size: 1.6rem;
          letter-spacing: -0.1rem;
        }
      }
      @include mq-max(450px) {
        top: 50%;
      }
      @include mq-landscape {
        top: 60%;
        left: 76%;
        a {
          padding: 0.5rem 1rem;
          font-size: 1.2rem;
          letter-spacing: -0.1rem;
        }
      }
      .btn {
        padding: 1.5rem 2.5rem;
        font-size: 3.2rem;
        @include mq-max(450px) {
          padding: 0.5rem 1rem;
          font-size: 2rem;
          letter-spacing: -0.1rem;
        }
        @include mq-landscape {
          padding: 1rem 2rem;
          font-size: 2rem;
        }
      }
    }
  }
  &__illus {
    position: absolute;
    right: 6%;
    top: 5%;
    @include mq-max(991px) {
      right: 50%;
      top: 35%;
      transform: translateX(50%);
      img {
        width: 35rem;
      }
    }
    @include mq-max(768px) {
      top: 40%;
      img {
        width: 25rem;
      }
    }
    @include mq-max(450px) {
      top: 35%;
      img {
        width: 20rem;
      }
    }
    @include mq-max(375px) {
      top: 29%;
      img {
        width: 20rem;
      }
    }
    @include mq-max(350px) {
      top: 25%;
      img {
        width: 20rem;
      }
    }
    @include mq-max-length(375px, 812px) {
      top: 32%;
    }
    @include mq-landscape {
      display: none;
    }
  }
  &__cta {
    position: absolute;
    top: 50%;
    left: 6%;
    color: $text-gray;
    font-family: Roboto;
    font-size: 2.4rem;
    font-weight: 300;
    line-height: 2.4rem;
    @include mq-max(991px) {
      top: 67%;
      left: 50%;
      transform: translateX(-50%);
    }
    @include mq-max(768px) {
      top: 63%;
    }
    @include mq-max(450px) {
      top: 53%;
    }
    @include mq-max(375px) {
      top: 48%;
    }
    @include mq-max(350px) {
      top: 43%;
    }
    @include mq-landscape {
      top: 38%;
      left: 6%;
      transform: unset;
    }
    @include mq-max-length(568px, 320px) {
      top: 32%;
    }
    @include mq-max-length(375px, 812px) {
      top: 50%;
    }
  }
  &__bottom-texts-left {
    position: absolute;
    top: 60%;
    left: 6%;
    @include mq-max(991px) {
      left: unset;
      top: unset;
      margin: 2.5rem;
      position: unset;
      .hero__bottom-texts-sub-texts {
        max-width: unset;
      }
    }
  }
  &__bottom-texts {
    @include mq-max(991px) {
      display: flex;
      flex-direction: column;
    }
    &-header {
      color: $primary;
      font-family: Roboto;
      font-size: 8.8rem;
      font-weight: bold;
      letter-spacing: -0.3rem;
      line-height: 7.2rem;
      margin-bottom: 4.8rem;
      @include mq-max(1200px) {
        font-size: 5.5rem;
        line-height: 5.2rem;
      }
      @include mq-max(991px) {
        margin-bottom: 2.5rem;
      }
    }
    &-sub-texts {
      color: $text-light-gray;
      font-family: Roboto;
      font-size: 3.2rem;
      font-weight: 500;
      letter-spacing: -0.2rem;
      line-height: 3.2rem;
      max-width: 50%;
      @include mq-max(1550px) {
        font-size: 2.6rem;
      }
      @include mq-max(1200px) {
        font-size: 2.2rem;
      }
    }
  }
  &__bottom-texts-right {
    position: absolute;
    top: 60%;
    right: 6%;
    max-width: 30vw;
    @include mq-max(991px) {
      padding: 2.5rem;
      padding-top: 0;
      top: unset;
      left: unset;
      max-width: unset;
      position: unset;
    }
  }
  &__bottom-text {
    color: $white;
    font-family: Roboto;
    font-size: 2.2rem;
    letter-spacing: -0.1rem;
    line-height: 3.2rem;
    text-align: right;
    @include mq-max(1490px) {
      font-size: 1.8rem;
    }
    @include mq-max(1090px) {
      font-size: 1.6rem;
    }
    @include mq-max(991px) {
      color: black;
      text-align: unset;
      color: $text-gray;
      font-family: Roboto;
      font-size: 2.2rem;
      font-weight: 300;
      letter-spacing: -0.1rem;
      line-height: 3.2rem;
    }
  }
}
</style>
